module.exports = __webpack_public_path__ + "static/img/tb2.9fcf6224.png";